import { UserUtils, userUtils } from "@/stores/UserStore";
import { useOperationModal } from "./useOperationModal";
import { userAnotherPanelState } from "@/stores/ComponentsState/UserAnotherPanelState";

export const useOperationModalForAnotherUsers = () => {
  return useOperationModal<UserUtils>(userUtils, userAnotherPanelState.modalData);
};
